/* import __COLOCATED_TEMPLATE__ from './custom-action-header-title.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import templateOnlyComponent from '@ember/component/template-only';
import type Action from 'embercom/models/workflow-connector/action';

interface Args {
  workflowAction: Action;
}

interface Signature {
  Args: Args;
  Element: Element;
}

const CustomActionHeaderTitle = templateOnlyComponent<Signature>();
export default CustomActionHeaderTitle;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'WorkflowConnector::CustomActionHeaderTitle': typeof CustomActionHeaderTitle;
    'workflow-connector/custom-action-header-title': typeof CustomActionHeaderTitle;
  }
}
